"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MIDDLEWARE_IDENTIFIER = 'analytics';
var debuggingEnabled = false;
exports.fireImmediately = function (queuedDataUpdates, lastEventTimestamp) {
    // tslint:disable-next-line:max-line-length
    return queuedDataUpdates.length === 0 && lastEventTimestamp && exports.enoughTimeElapsed(lastEventTimestamp.getLastTimestamp());
};
exports.enableDebugging = function (val) {
    debuggingEnabled = val;
};
exports.fireAnalyticsFromEventQueue = function (lastEventTimestamp, queuedDataUpdates, dataIsland) {
    try {
        lastEventTimestamp.update();
        if (queuedDataUpdates.length > 0) {
            dataIsland.update(queuedDataUpdates.shift());
        }
    }
    catch (err) {
        if (debuggingEnabled) {
            console.error('Failed to fire analytics', err.toString());
        }
    }
};
exports.eventTimestampManager = function () {
    var timestamp = undefined;
    return {
        update: function (override) {
            timestamp = override || Date.now();
        },
        getLastTimestamp: function () {
            return timestamp;
        }
    };
};
exports.enoughTimeElapsed = function (lastEventTimestamp) {
    if (lastEventTimestamp === void 0) { lastEventTimestamp = 0; }
    return Date.now() - lastEventTimestamp >= 1600;
};
exports.shouldExecute = function (action) {
    return Boolean(action &&
        action.meta &&
        action.meta.middleware &&
        action.meta.middleware[MIDDLEWARE_IDENTIFIER]);
};
function convertDateToUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}
exports.convertDateToUTC = convertDateToUTC;
